import { Snowflake } from "lucide-react";
import { useLang } from "../../lib/i18n";

export const CostTag = ({ n, testId }) => {
  const { t } = useLang();
  if (n == null) return null;
  return (
    <span className="frz-cost" data-testid={testId}>
      <Snowflake size={11} /> {n === 0 ? t("free") : `${n} ${t(n === 1 ? "credit_word_one" : "credit_word_many")}`}
    </span>
  );
};
